import {get, set} from 'idb-keyval';

export const saveMswValue: (key: string, value: string) => void = async (key, value) => set(key, value);

export const loadMswValue: (key: string) => any = async key => get(key);
